/* eslint-disable camelcase */
export type MetricDetail = {
    metric_type_name: string;
    metric_value: number | null;
    metric_id: number;
    percent_to_target:string;
    metric_rank:number;
    metric_rank_percentile:string;
};
 
// Function to format rank with suffix
export const getRankSuffix = (rank: number) => {
    const suffixes = ["th", "st", "nd", "rd"];
    const v = rank % 100;
    return rank + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
};

// Color codes for top 3 ranks
export const rankColors: { [key: number]: string } = {
    1: "#FEF2C7", // Gold
    2: "#EDEDED", // Silver
    3: "#FEE6CF" , // Bronze
    4: "#ECECFE",  // Purple
    5: "#FFFFFF",  // Default
};

export interface View {
    name: string;
    code: string;
};

export const views: View[] = [
    { name: 'Global', code: '1' },
    { name: 'Team Lead', code: '2' },
    { name: 'Manager', code: '3' },
];

export const TeamLeadviews: View[] = [
    { name: 'Global', code: '1' },
    { name: 'Manager', code: '2' },
];

export const getNameById = (data:any,id:number) => {
    const result = data.find((item:any) => item.id === id);
    return result ? result.name : "Not Found";
};

export const formatPercentage = (value:number) => {
    if (value === undefined || value === null) {
        return '--';
    }
    return `${(value * 100)?.toFixed(2)}%`;
};

export type RankingItem = {
    employee_name: string;
    metricType?: string;
    metric_value: number;
    metric_rank: number;
    selected: boolean;
    looged_in_user?: string;
  };

// Format values based on metricType
export const formatMetricValue = (value: number, metricType: string): string => {
    if (value === undefined || value === null) {
        return '--';
    }
    // Add % symbol if metricType is 'percentage'
    if (metricType?.toLowerCase() === 'percentage') {
        const val = value * 100;
        return `${val.toFixed(2)}%`;
    }

    // Otherwise return just the formatted number
    return value.toString();
};

export const extractAndSortMetricDetailsById = (data: any, targetMetricId: number, selectedUserInGrid: any,empNum:any) => {
        if (!Array.isArray(data) || data.length === 0) return { all: [], top3: [] };

        const extracted: RankingItem[] = data.flatMap((agent) => {
            if (!agent.agentMetrics || !Array.isArray(agent.agentMetrics)) return [];
            return agent.agentMetrics.flatMap((metricGroup: any) => {
                if (!metricGroup.metricsDetails || typeof metricGroup.metricsDetails !== 'object') return [];
                return Object.values(metricGroup.metricsDetails)
                    .filter((metric: any) => metric && metric.metric_id === targetMetricId)
                    .map((metric: any) => ({
                        employee_name: agent.employee_name,
                        metricType: metric.metric_type_name,
                        metric_value: metric.metric_value,
                        metric_rank: metric.metric_rank,
                        selected: agent.agentMetrics[0].employee_number === selectedUserInGrid?.employee_number,
                        looged_in_user: empNum,
                        is_logged_in_user: agent.employee_number === empNum,
                    }));
            });
        });
        // Sort with valid ranks first, invalid at the end
        const sorted = extracted.sort((a, b) => {
            const aValid = typeof a.metric_rank === 'number' && !isNaN(a.metric_rank);
            const bValid = typeof b.metric_rank === 'number' && !isNaN(b.metric_rank);

            if (aValid && bValid) return a.metric_rank - b.metric_rank;
            if (aValid) return -1;
            if (bValid) return 1;
            return 0;
        });

        // Take top 3 valid-ranked items
        const top3 = sorted.filter(
            (item) =>
                typeof item.metric_rank === 'number' &&
                !isNaN(item.metric_rank) &&
                item.metric_rank > 0 &&
                item.metric_rank <= 3
        );
        //.slice(0, 3);

        return { all: sorted, top3 };
    };